const state = {
  frontStore:
    [
      {
        id: 1,
        title_en: "Vue.js Starter 2021",
        title_ua: "Vue.js Стартовий 2021",
        title_es: "Vue.js Inicio 2021",
        regnumber: "TP75556859",
        grade: "1000 / 1000",
        examdate: "11.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp75556859",
      },
      {
        id: 2,
        title_en: "Vue.js Starter 2023",
        title_ua: "Vue.js Стартовий 2023",
        title_es: "Vue.js Inicio 2023",
        regnumber: "TP70934717",
        grade: "1000 / 1000",
        examdate: "05.09.2023",
        image: "https://testprovider.com/ru/search-certificate/tp70934717",
      },
      {
        id: 3,
        title_en: "Vue.js Essential",
        title_ua: "Vue.js Базовий",
        title_es: "Vue.js Básico",
        regnumber: "TP51164572",
        grade: "1000 / 1000",
        examdate: "17.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp51164572",
      },
      {
        id: 4,
        title_en: "Building one page site with Vue.js",
        title_ua: "Створення односторінкового сайту на Vue.js",
        title_es: "Construyendo un sitio de una página con Vue.js",
        regnumber: "TP29746655",
        grade: "1000 / 1000",
        examdate: "23.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp29746655",
      },
      {
        id: 5,
        title_en: "jQuery 2014",
        title_ua: "jQuery 2014",
        title_es: "jQuery 2014",
        regnumber: "TP41571029",
        grade: "1000 / 1000",
        examdate: "09.07.2021",
        image: "https://testprovider.com/ru/search-certificate/tp41571029",
      },
      {
        id: 6,
        title_en: "jQuery 2021",
        title_ua: "jQuery 2021",
        title_es: "jQuery 2021",
        regnumber: "TP55404559",
        grade: "1000 / 1000",
        examdate: "23.09.2021",
        image: "https://testprovider.com/ru/search-certificate/tp55404559",
      },
      {
        id: 7,
        title_en: "HTML5 Web Components",
        title_ua: "Веб-компоненти HTML5",
        title_es: "Componentes Web HTML5",
        regnumber: "TP75653206",
        grade: "1000 / 1000",
        examdate: "30.07.2021",
        image: "https://testprovider.com/ru/search-certificate/tp75653206",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};